var React = require('react');

function Cheese (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M299.83 32C418 38.22 512 136.13 512 256H0L278.7 39a32 32 0 0 1 21.13-7z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M512 288v160a32 32 0 0 1-32 32H32a32 32 0 0 1-32-32V288z","className":"fa-primary","key":2})]);
}

Cheese.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Cheese;

Cheese.default = Cheese;
